// import { Button } from "@mantine/core";
// import CustomInput from "components/CustomInput/CustomInput";
// import React, { useState } from "react";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
// import axios from "axios";
// import SweetAlert from "react-bootstrap-sweetalert";
// //const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
// import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
// import { makeStyles } from "@material-ui/core/styles";
// const useStyleData = makeStyles(stylesData);
// import { usenavigate } from "react-router-dom";

// export default function AddWithdrawal() {
//   const navigate = usenavigate();
//   const [formData, setFormData] = useState({
//     name: "",
//     currency: "",
//     rate: "",
//     minAmount: "",
//     maxAmount: "",
//     fixedCharge: "",
//     percentageCharge: "",
//     userDate: [{ label: "", type: "" }],
//   });

//   const [alert, setAlert] = React.useState(null);

//   const [errors, setErrors] = useState({});

//   const hideAlert = () => {
//     setAlert(null);
//     navigate(`/admin/manageWithdrawalMethods`);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     const token = localStorage.getItem("token");
//     const validationErrors = validateForm(formData);
//     setErrors(validationErrors);

//     if (Object.keys(validationErrors).length === 0) {
//       // Convert the withdrawal instructions to the desired format
//       const formattedWithdrawInstraction = {};
//       formData.userDate.forEach((instruction, index) => {
//         formattedWithdrawInstraction[`userDate[${index}][label]`] =
//           instruction.label;
//         formattedWithdrawInstraction[`userDate[${index}][type]`] =
//           instruction.type;
//       });

//       // Combine the formatted data with the rest of the form data
//       const finalFormData = {
//         ...formData,
//         withdrawInstraction: formattedWithdrawInstraction,
//       };

//       axios
//         .post(
//           `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail`,
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               // 'Content-Type': 'application/json',
//               // "Access-Control-Allow-Origin": "*",
//             },
//           }
//         )
//         .then((res) => {
//           setAlert(
//             <SweetAlert
//               style={{ display: "block", marginTop: "-100px" }}
//               title={
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {res.data.message}
//                 </span>
//               }
//               onConfirm={() => hideAlert()}
//               onCancel={() => hideAlert()}
//               titleCssClass={classesSweetAlert.cardTitle}
//               confirmBtnCssClass={
//                 classesSweetAlert.button + " " + classesSweetAlert.success
//               }
//             />
//           );
//         })
//         .catch((err) => {
//           console.warn(err);
        
//           // Extract a human-readable error message
//           const errorMessage =
//             err.response?.data?.message || "An error occurred. Please try again.";
        
//           setAlert(
//             <SweetAlert
//               style={{ display: "block", marginTop: "-100px" }}
//               title={
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {errorMessage}
//                 </span>
//               }
//               onConfirm={() => hideAlert()}
//               onCancel={() => hideAlert()}
//               titleCssClass={classesSweetAlert.cardTitle}
//               confirmBtnCssClass={
//                 classesSweetAlert.button + " " + classesSweetAlert.success
//               }
//             />
//           );
//         });
        
//       // Send the finalFormData to the server or perform any further actions
//       console.log("Form submitted successfully!", finalFormData);
//     }
//   };

//   const validateForm = (data) => {
//     const errors = {};

//     if (data.name.trim() === "") {
//       errors.name = "Name is required";
//     }

//     if (data.currency.trim() === "") {
//       errors.currency = "Currency is required";
//     }

//     if (isNaN(data.rate) || parseFloat(data.rate) <= 0) {
//       errors.rate = "Invalid rate";
//     }

//     if (isNaN(data.minAmount) || parseFloat(data.minAmount) <= 0) {
//       errors.minAmount = "Invalid minimum amount";
//     }

//     if (isNaN(data.maxAmount) || parseFloat(data.maxAmount) <= 0) {
//       errors.maxAmount = "Invalid maximum amount";
//     }

//     if (parseFloat(data.minAmount) > parseFloat(data.maxAmount)) {
//       errors.maxAmount = "Maximum amount must be greater than minimum amount";
//     }

//     if (isNaN(data.fixedCharge) || parseFloat(data.fixedCharge) < 0) {
//       errors.fixedCharge = "Invalid fixed charge";
//     }

//     if (
//       isNaN(data.percentageCharge) ||
//       parseFloat(data.percentageCharge) < 0 ||
//       parseFloat(data.percentageCharge) > 100
//     ) {
//       errors.percentageCharge = "Invalid percentage charge";
//     }

//     return errors;
//   };

//   const handleInputChange = (event) => {
//     const { id, value } = event.target;
//     setFormData({ ...formData, [id]: value });
//     console.log(formData);
//   };

//   const handleInstructionChange = (index, event) => {
//     const { id, value } = event.target;
//     const newInstructions = [...formData.userDate];
//     newInstructions[index] = { ...newInstructions[index], [id]: value };
//     setFormData({ ...formData, userDate: newInstructions });
//   };

//   const addInstruction = () => {
//     setFormData({
//       ...formData,
//       userDate: [...formData.userDate, { label: "", type: "" }],
//     });
//   };

//   const removeInstruction = (index) => {
//     const newInstructions = [...formData.userDate];
//     newInstructions.splice(index, 1);
//     setFormData({ ...formData, userDate: newInstructions });
//   };

//   const classesSweetAlert = useStyleData();
//   return (
//     <form onSubmit={handleSubmit}>
//       <label htmlFor="name">Name:</label>
//       <CustomInput
//         type="text"
//         id="name"
//         name="name"
//         value={formData.name}
//         handleChange={handleInputChange}
//       />
//       {errors.name && <p>{errors.name}</p>}

//       <label htmlFor="currency">Currency:</label>
//       <CustomInput
//         type="text"
//         id="currency"
//         name="currency"
//         value={formData.currency}
//         handleChange={handleInputChange}
//       />
//       {errors.currency && <p>{errors.currency}</p>}

//       <label htmlFor="rate">Rate:</label>
//       <CustomInput
//         type="number"
//         id="rate"
//         name="rate"
//         value={formData.rate}
//         handleChange={handleInputChange}
//       />
//       {errors.rate && <p>{errors.rate}</p>}

//       <label htmlFor="minAmount">Minimum Amount:</label>
//       <CustomInput
//         type="number"
//         id="minAmount"
//         name="minAmount"
//         value={formData.minAmount}
//         handleChange={handleInputChange}
//       />
//       {errors.minAmount && <p>{errors.minAmount}</p>}

//       <label htmlFor="maxAmount">Maximum Amount:</label>
//       <CustomInput
//         type="number"
//         id="maxAmount"
//         name="maxAmount"
//         value={formData.maxAmount}
//         handleChange={handleInputChange}
//       />
//       {errors.maxAmount && <p>{errors.maxAmount}</p>}

//       <label htmlFor="fixedCharge">Fixed Charge:</label>
//       <CustomInput
//         type="number"
//         id="fixedCharge"
//         name="fixedCharge"
//         value={formData.fixedCharge}
//         handleChange={handleInputChange}
//       />
//       {errors.fixedCharge && <p>{errors.fixedCharge}</p>}

//       <label htmlFor="percentageCharge">Percentage Charge:</label>
//       <CustomInput
//         type="number"
//         id="percentageCharge"
//         name="percentageCharge"
//         value={formData.percentageCharge}
//         handleChange={handleInputChange}
//       />
//       {errors.percentageCharge && <p>{errors.percentageCharge}</p>}

//       {/* <h2>Withdrawal Instructions:</h2>
//       <GridContainer container>
//         {formData.userDate.map((instr, index) => (
//           <GridItem item xs={4} key={index} style={{ marginBottom: "20px" }}>
//             <label htmlFor="label">Label {index + 1}:</label>
//             <CustomInput
//               type="text"
//               id="label"
//               name="label"
//               value={instr.label}
//               handleChange={(event) => handleInstructionChange(index, event)}
//             />
//             <br />

//             <label htmlFor="type">Type {index + 1}:</label>
//             <CustomInput
//               type="text"
//               id="type"
//               name="type"
//               value={instr.type}
//               handleChange={(event) => handleInstructionChange(index, event)}
//             />
//             <br />
//             {errors[`withdrawalInstruction-${index}`] && (
//               <p>{errors[`withdrawalInstruction-${index}`]}</p>
//             )}

//             <Button type="button" onClick={() => removeInstruction(index)}>
//               Remove Instruction
//             </Button>
//           </GridItem>
//         ))}
//       </GridContainer>

//       <Button type="button" onClick={addInstruction}>
//         Add Instruction
//       </Button> */}
//       {alert}
//       {/* Add more label and type fields as needed */}
//       {/* e.g., */}
//       {/* <label htmlFor="label2">Label 2:</label> */}
//       {/* <input type="text" id="label2" name="label2" value={formData.label2} onChange={handleInputChange} /> */}
//       {/* <br /> */}

//       {/* <label htmlFor="type2">Type 2:</label> */}
//       {/* <input type="text" id="type2" name="type2" value={formData.type2} onChange={handleInputChange} /> */}
//       {/* <br /> */}

//       <Button type="submit" style={{ marginTop: "20px", display: "flex" }}>
//         Submit
//       </Button>
//     </form>
//   );
// }




import React, { useState } from "react";
import { Button, TextField, Grid, Typography, Box, Alert } from "@mui/material";
import axios from "../../utils/axiosInstance"; 
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles(styles);
export default function AddWithdrawal() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    currency: "",
    rate: "",
    minAmount: "",
    maxAmount: "",
    fixedCharge: "",
    percentageCharge: "",
    userDate: [{ label: "", type: "" }],
  });

  const [alert, setAlert] = React.useState(null);
  const [errors, setErrors] = useState({});

  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/manageWithdrawalMethods`);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const formattedWithdrawInstraction = {};
      formData.userDate.forEach((instruction, index) => {
        formattedWithdrawInstraction[`userDate[${index}][label]`] =
          instruction.label;
        formattedWithdrawInstraction[`userDate[${index}][type]`] =
          instruction.type;
      });

      const finalFormData = {
        ...formData,
        withdrawInstraction: formattedWithdrawInstraction,
      };

      axios
        .post(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail`,
          finalFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={<Typography variant="h6">{res.data.message}</Typography>}
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
            />
          );
        })
        .catch((err) => {
          const errorMessage =
            err.response?.data?.message || "An error occurred. Please try again.";
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={<Typography variant="h6">{errorMessage}</Typography>}
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
            />
          );
        });
    }
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.name.trim()) {
      errors.name = "Name is required";
    }

    if (!data.currency.trim()) {
      errors.currency = "Currency is required";
    }

    if (isNaN(data.rate) || parseFloat(data.rate) <= 0) {
      errors.rate = "Invalid rate";
    }

    if (isNaN(data.minAmount) || parseFloat(data.minAmount) <= 0) {
      errors.minAmount = "Invalid minimum amount";
    }

    if (isNaN(data.maxAmount) || parseFloat(data.maxAmount) <= 0) {
      errors.maxAmount = "Invalid maximum amount";
    }

    if (parseFloat(data.minAmount) > parseFloat(data.maxAmount)) {
      errors.maxAmount = "Maximum amount must be greater than minimum amount";
    }

    if (isNaN(data.fixedCharge) || parseFloat(data.fixedCharge) < 0) {
      errors.fixedCharge = "Invalid fixed charge";
    }

    if (
      isNaN(data.percentageCharge) ||
      parseFloat(data.percentageCharge) < 0 ||
      parseFloat(data.percentageCharge) > 100
    ) {
      errors.percentageCharge = "Invalid percentage charge";
    }

    return errors;
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFormData({ ...formData, [id]: value });
  };

 

  return (
    <>
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Manage Withdrawal</h4>
           
          </CardHeader>
    <Box component="form" onSubmit={handleSubmit} sx={{ padding: 4 }}>
      <Typography variant="h5" gutterBottom>
        Add Withdrawal Method
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Name"
            id="name"
            value={formData.name}
            onChange={handleInputChange}
            error={!!errors.name}
            helperText={errors.name}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Currency"
            id="currency"
            value={formData.currency}
            onChange={handleInputChange}
            error={!!errors.currency}
            helperText={errors.currency}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Rate"
            type="number"
            id="rate"
            value={formData.rate}
            onChange={handleInputChange}
            error={!!errors.rate}
            helperText={errors.rate}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Minimum Amount"
            type="number"
            id="minAmount"
            value={formData.minAmount}
            onChange={handleInputChange}
            error={!!errors.minAmount}
            helperText={errors.minAmount}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Maximum Amount"
            type="number"
            id="maxAmount"
            value={formData.maxAmount}
            onChange={handleInputChange}
            error={!!errors.maxAmount}
            helperText={errors.maxAmount}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Fixed Charge"
            type="number"
            id="fixedCharge"
            value={formData.fixedCharge}
            onChange={handleInputChange}
            error={!!errors.fixedCharge}
            helperText={errors.fixedCharge}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Percentage Charge"
            type="number"
            id="percentageCharge"
            value={formData.percentageCharge}
            onChange={handleInputChange}
            error={!!errors.percentageCharge}
            helperText={errors.percentageCharge}
          />
        </Grid>

        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Submit
          </Button>
        </Grid>

        {alert && <Grid item xs={12}>{alert}</Grid>}
      </Grid>
    </Box>
    </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
